webpackJsonp([1],{

/***/ 111:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'middle'
    },
    type: {
      type: String,
      default: 'text'
    },
    time: {
      type: String,
      default: '3000'
    },
    msg: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      toastShow: this.show
    };
  },

  methods: {
    autoShowHide: function autoShowHide() {
      this.toastShow = this.show;
      setTimeout(function () {
        this.toastShow = false;
        this.$emit('toast-hide');
      }.bind(this), this.time);
    }
  },
  mounted: function mounted() {
    this.autoShowHide();
  },

  watch: {
    show: function show() {
      this.autoShowHide();
    }
  }
};

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Toast = __webpack_require__(41);

var _Toast2 = _interopRequireDefault(_Toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Toast: _Toast2.default
  },
  data: function data() {
    return {
      toast: {
        show: true,
        position: 'top',
        type: 'text',
        time: '2000',
        msg: 'hello vueUI'
      }
    };
  },

  methods: {
    toastHide: function toastHide() {
      this.toast.show = false;
    },
    showToast: function showToast(item) {
      switch (item) {
        case 1:
          this.toast = {
            show: true,
            position: 'middle',
            type: 'text',
            time: '3000',
            msg: '默认就是我这样的'
          };
          break;
        case 2:
          this.toast = {
            show: true,
            position: 'middle',
            type: 'text',
            time: '2000',
            msg: '我显示2s'
          };
          break;
        case 3:
          this.toast = {
            show: true,
            position: 'top',
            type: 'text',
            time: '3000',
            msg: '我在顶部显示'
          };
          break;
        case 4:
          this.toast = {
            show: true,
            position: 'bottom',
            type: 'text',
            time: '3000',
            msg: '我在底部显示'
          };
          break;
        case 5:
          this.toast = {
            show: true,
            position: 'middle',
            type: 'warn',
            time: '3000',
            msg: '我是警告类型的提示'
          };
          break;
        case 6:
          this.toast = {
            show: true,
            position: 'middle',
            type: 'cancel',
            time: '6000',
            msg: '我是取消类型的提示, 我会展示6s哦'
          };
          break;
        case 7:
          this.toast = {
            show: true,
            position: 'middle',
            type: 'cancel',
            time: '1000',
            msg: '我只显示1s, 看好了'
          };
          break;
      }
    }
  }
};

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(26);


/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(4)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(3),
  /* scopeId */
  "data-v-12f6e127",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _Toast = __webpack_require__(55);

var _Toast2 = _interopRequireDefault(_Toast);

var _router = __webpack_require__(5);

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;

new _vue2.default({
  el: '#toast',
  router: _router2.default,
  template: '<Toast/>',
  components: { Toast: _Toast2.default }
});

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(97)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(68),
  /* scopeId */
  "data-v-52c19bfc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(7);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Index = __webpack_require__(2);

var _Index2 = _interopRequireDefault(_Index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  routes: [{
    path: '/',
    name: 'Index',
    component: _Index2.default
  }]
});

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(111)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(82),
  /* scopeId */
  "data-v-e1816784",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "toast"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toastShow == true),
      expression: "toastShow==true"
    }],
    staticClass: "toast",
    class: {
      top: _vm.position === 'top', middle: _vm.position === 'middle', bottom: _vm.position === 'bottom'
    }
  }, [(_vm.type === 'cancel') ? _c('span', {
    staticClass: "icon-cancel"
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'warn') ? _c('span', {
    staticClass: "icon-warn"
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.msg) + "\n  ")])])
},staticRenderFns: []}

/***/ }),

/***/ 82:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "默认"
    },
    on: {
      "click": function($event) {
        _vm.showToast(1)
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "中部"
    },
    on: {
      "click": function($event) {
        _vm.showToast(2)
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "顶部"
    },
    on: {
      "click": function($event) {
        _vm.showToast(3)
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "底部"
    },
    on: {
      "click": function($event) {
        _vm.showToast(4)
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "警告"
    },
    on: {
      "click": function($event) {
        _vm.showToast(5)
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "取消"
    },
    on: {
      "click": function($event) {
        _vm.showToast(6)
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "1s消失"
    },
    on: {
      "click": function($event) {
        _vm.showToast(7)
      }
    }
  }), _vm._v(" "), _c('Toast', {
    attrs: {
      "show": _vm.toast.show,
      "position": _vm.toast.position,
      "type": _vm.toast.type,
      "time": _vm.toast.time,
      "msg": _vm.toast.msg
    },
    on: {
      "toast-hide": _vm.toastHide
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[152]);


// WEBPACK FOOTER //
// static/js/toast.b0eece4f783fbcfd0357.js